import React from "react";
import { SECTIONS } from "../lib/sections";
import { Command } from "@phosphor-icons/react";

export default function Sidebar({ section, onSection, onOpenPalette }) {
  return (
    <aside
      data-testid="sidebar"
      className="bg-slate-950 border-r border-slate-800 flex flex-col w-64 shrink-0 sticky top-0 h-screen overflow-y-auto thin-scroll"
    >
      <div className="px-6 py-5 border-b border-slate-800">
        <div
          className="font-serif-brand text-[22px] font-semibold leading-none text-slate-50"
          style={{ letterSpacing: "0.02em" }}
        >
          PROCUREO
        </div>
        <div className="font-inter text-[10px] text-slate-400 mt-2 tracking-normal">
          Category Strategy · v0.2
        </div>
      </div>

      <button
        data-testid="sidebar-open-palette"
        onClick={onOpenPalette}
        className="mx-6 mt-3 mb-2 flex items-center gap-2 px-3 py-2 rounded-sm border border-slate-700 bg-slate-900 hover:border-slate-500 hover:bg-slate-800 transition-colors text-left"
      >
        <Command weight="bold" className="text-slate-400" size={14} />
        <span className="text-[11px] text-slate-300 flex-1">Command…</span>
        <kbd className="text-[9px] font-mono text-slate-500 border border-slate-700 px-1 py-0.5 rounded-sm">⌘K</kbd>
      </button>

      <nav className="flex-1 py-2 space-y-1">
        {SECTIONS.map((group) => (
          <div key={group.group}>
            <div
              data-testid={`sidebar-group-${group.group.toLowerCase()}`}
              className="px-6 py-4 tracking-mono-label text-[10px] text-slate-500"
            >
              {group.group}
            </div>
            <div>
              {group.items.map((item) => {
                const Icon = item.icon;
                const isActive = section === item.id;
                return (
                  <button
                    key={item.id}
                    data-testid={`section-${item.id}`}
                    onClick={() => onSection(item.id)}
                    className={`w-full flex items-center gap-3 px-6 py-2 text-left transition-colors text-[12px] ${
                      isActive
                        ? "bg-slate-900 text-slate-50 border-r-2 border-slate-900"
                        : "text-slate-400 hover:bg-slate-900 hover:text-slate-100 border-r-2 border-transparent"
                    }`}
                  >
                    <Icon weight={isActive ? "fill" : "regular"} size={14} />
                    <span className="truncate">{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </nav>

      <footer className="px-6 py-3 border-t border-slate-800 text-[10px] font-mono text-slate-500 leading-relaxed">
        Procureo Engine · Source of Truth + Context Ledger
        <br />
        Procureo Intelligence Engine
      </footer>
    </aside>
  );
}
